import React from 'react';
import {observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Row, Col, Media, Badge} from 'react-bootstrap';
import DeleteButton from '../common_components/DeleteButton';
import CommentForm from './CommentForm';
import Attachments from '../common_components/attachments/Attachments';
import {inject} from "mobx-react/index";
import Text from 'react-format-text';

@injectIntl @observer
export default class Comment extends React.Component {

    render() {
        const {comment, notEditable} = this.props;
        if( comment.isEditing ){
            return <CommentForm {...this.props} />;
        }
        else{
            return <CommentBody {...this.props} />;
        }
    }

}

@injectIntl @inject('authorizationsStore') @observer
class CommentBody extends React.Component{
    render(){
        const {comment, intl, authorizationsStore, notEditable} = this.props;
        return (
            <Media className={"feedback-comment"}>
                <Media.Left>
                    <div className={"img-thumbnail img-circle"}>
                        <img className="img-responsive" src={comment.creator.profilePhotoUrl}
                             alt={comment.creator.name+" thumbnail"}/>
                    </div>
                    <div className="creator-name" > {comment.creator.name} </div>
                </Media.Left>
                <Media.Body>
                    <Row>
                        <Col xs={12} md={12} className={''}>
                            { authorizationsStore.canEditComment(comment) && !notEditable &&
                                <div className="comment-actions">
                                    <button className={'fa fa-pencil btn-transparent'} onClick={() => comment.setIsEditing(true)} />
                                    <DeleteButton onDelete={() => comment.destroy()} />
                                </div>
                            }
                            <div className="comment-body">
                                <Text>{comment.description}</Text>
                            </div>
                            <Attachments attachable={comment} />
                            <div className="comment-footer text-muted small">
                                {comment.internal && <Badge>{intl.formatMessage({id: "internal"})}</Badge>}
                                <div>{intl.formatMessage({id: "updated_at"})}&nbsp;{comment.updatedAt.format("LL")}</div>
                            </div>
                        </Col>
                    </Row>
                </Media.Body>
            </Media>
        );
    }
}
